import { loadSummaries } from 'owa-timestream-store';

export function bootstrapCalendarBoardProject() {
    loadCalendarBoardProjects();
}

export function loadCalendarBoardProjects() {
    loadSummaries();
}
